import { APICore } from "../apiCore";
import { getGuildApiParams } from "../../Guild/guildUtils";

const api = new APICore();

function getShowMediaBySlug(showSlug, mediaSlug) {
  return api.get(`/show/${showSlug}/media/${mediaSlug}`, getGuildApiParams());
}

// All of a show's media sections in one request, keyed by tag
function getShowMediaByTags(genreSlug, showSlug, tags) {
  return api.get(`/genre/${genreSlug}/show/${showSlug}/media`, {
    ...getGuildApiParams(),
    tags: tags.join(","),
  });
}

function getShowMediaByTag(genreSlug, showSlug, tag) {
  return api.get(
    `/genre/${genreSlug}/show/${showSlug}/media/tag/${tag}`,
    getGuildApiParams(),
  );
}

function getShowAlbums(genreSlug, showSlug) {
  return api.get(
    `/genre/${genreSlug}/show/${showSlug}/albums`,
    getGuildApiParams(),
  );
}

export {
  getShowMediaBySlug,
  getShowMediaByTag,
  getShowMediaByTags,
  getShowAlbums,
};
